import axios from "./axiosInstance";
import { Globals } from "../global/Globals";
import CryptoUtils from "../util/cryptoUtils";

export const fetch_All_AuditTrail_Proposals = async (Filters, pageNumber, RoleID) => {
  const selectedRoleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const ApiEndpoint = Globals.ENDPOINT.AUDITTRAILPROPOSALS +"roleId="+selectedRoleId;

  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: Filters,
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = ApiEndpoint;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const fetch_All_AuditTrail_Briefs = async (Filters, pageNumber, RoleID) => {
  const selectedRoleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const ApiEndpoint = Globals.ENDPOINT.AUDITTRAILBRIEFS +"roleId="+selectedRoleId; 

  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: Filters,
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };
  const endpoint = ApiEndpoint;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const fetchFilterClusters = async () => {
  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };
  const endpoint = Globals.ENDPOINT.FETCH_ALL_CLUSTERS;
  const apiResponse = await axios.get(endpoint, config);
  const transformedResult = apiResponse.data.content.map((item) => ({
    id: item.clusterId,
    name: item.clusterName,
  }));
  apiResponse.data.clusteInfo = transformedResult;
  return apiResponse;
};

export const DownloadAuditTrail = async (Filters,activeTab) => {
  const selectedRoleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const data = {
     Filters,
  };
  const config = {
    header: { Accept: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" },
  };
  const endpoint = activeTab === "Proposal Audit Trail" ? Globals.ENDPOINT.EXPORTAUDITTRAILPROPOSALS + selectedRoleId : Globals.ENDPOINT.EXPORTAUDITTRAILBRIEFS  + selectedRoleId ;
  const apiResponse = await axios.post(endpoint, Filters, config);
  return apiResponse;
};

export const fetchFilterActions = async (roleID, ClusterId) => {
  const body = { roleIds: ["2","3","4","6"], clusterIds: ClusterId, isDeleted: false };
  let FinalEndpoint = Globals.ENDPOINT.FILTERACTIONBY;
  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };
  const apiResponse = await axios.post(FinalEndpoint, body, config);
  const transformedResult = apiResponse.data.content.map((item) => ({
    id: item.id,
    name: item.name,
  }));
  apiResponse.data.actionBy = transformedResult;
  return apiResponse;
};
